
<template>
  <div v-title="`${types==1?'下级商家':''} ${types==2?'下级客户':''}`" class="home">
    <!--付款成功-->
    <van-loading v-show="show" type="spinner" class="home-loadings" color="#1989fa" />
    <div v-if="!show">
      <div v-if="dada">
        <van-cell-group v-for="(item,i) in dada" :key="i">
          <div data-v-2c14c045 class="van-cell">
            <img v-lazy="item.avatar" />
            <div data-v-2c14c045 class="van-cell__title van-cell__titles">
              <p data-v-2c14c0456 v-if="types==1">{{item.business_name}}</p>
              <p data-v-2c14c045 :class="types==1?'closcl':''">昵称： {{item.nickname}}</p>
            </div>
            <div data-v-2c14c045 class="van-cell__value van-cell__values">
              <p data-v-2c14c045>累计交易(￥)</p>
              <p data-v-2c14c045>{{ Math.floor((item.money/1000)   * 100) / 100}}</p>
            </div>
          </div>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserToken } from "@/utils/Cookie";
import { request } from "../../utils/https";
export default {
  name: "subordinate",
  data() {
    return {
      date: "",
      show: true,
      types: 2,
      dada: [
        // {
        //   name: "累计交易asdsdsadas",
        //   val: "1.56",
        //   den: "门店名称",
        //   img: "https://img.yzcdn.cn/vant/apple-1.jpg"
        // },
        // {
        //   name: "累计交易asdsdsadas",
        //   val: "1.56",
        //   den: "门店名称",
        //   img: "https://img.yzcdn.cn/vant/apple-1.jpg"
        // },
        // {
        //   name: "累计交易asdsdsadas",
        //   val: "1.56",
        //   den: "门店名称",
        //   img: "https://img.yzcdn.cn/vant/apple-1.jpg"
        // }
      ]
    };
  },
  methods: {
    async userShows() {
      if (this.types == 2) {
        // console.log(222);
        let res = await request("user/test/userShow?token="+getUserToken());
        if (res.data) {
          this.show = false;
          this.dada = res.data;
        }

      } else if (this.types == 1) {//使用原生ajax进行数据请求
        let res = await request("user/test/businessShow?token="+getUserToken());
        if (res.data) {
          this.show = false;
          this.dada = res.data;
        }
      }
    }
  },
  created() {
    if (this.$route.query.types) {//接收url中传值
      this.types = this.$route.query.types;
    }
  },
  mounted() {
    this.userShows();
  }
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  .van-cell-group {
    padding: 0.96875rem 0.75rem 0.875rem 0.75rem;
    .van-cell {
      padding: 0;
    }
    img {
      width: 3.75rem;
      height: 3.75rem;
      border-radius: 50%;
    }
    .van-cell__titles {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 59%;
      p {
        width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      p[data-v-2c14c0456] {
        padding-bottom: 0.75rem;
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
      .closcl {
        font-size: 1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
    .van-cell__values {



      display: flex;
      align-items: flex-end;
      justify-content: center;
      flex-direction: column;
      p {
        padding: 0;
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 163, 0, 1);
      }
      p:first-child {
        padding-bottom: 0.75rem;
        font-size: 0.8125rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
</style>
